import axios from 'axios'
import { STOCKS_ENDPOINT } from 'cfgCommon/endpoints'

export async function validateInconsistencies(step, files) {
  const inconsistencies = await axios.post(
    `${STOCKS_ENDPOINT}/validateStep`,
    {
      step,
      files
    },
    {
      timeout: 300000 // 5 minutos
    }
  ).then(res => res.data)
  return inconsistencies
}
